import script from "./HistoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryPage.vue?vue&type=script&setup=true&lang=js"

import "./HistoryPage.vue?vue&type=style&index=0&id=06367236&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06367236"]])

export default __exports__